import { useAuth } from "../../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { UserRoles } from "../../../types/user.types";
import { useTeam } from "../../../context/TeamContext";
import { useEffect } from "react";
import { ErrorMessage } from "../../../components/error-message";
import { BoatInfoPrimaryUser } from "../boat-information/boat-info-primary-user";
import { BoatInfoDisplay } from "../boat-information/boat-info-display";
import { Loading } from "../../../components/loading";
import bgCreateBoat from "../../../assets/bgCreateBoat.jpg";
import { ShipIcon } from "lucide-react";

export function MyBoat() {
  const { user } = useAuth();
  const { getTeam, isLoading, error, team } = useTeam();

  useEffect(() => {
    getTeam();
  }, [getTeam]);

  if (
    ![UserRoles.PRIMARY_USER, UserRoles.INVITED_USER].includes(user!.roleId)
  ) {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative overflow-hidden bg-fixed"
      style={{ backgroundImage: `url(${bgCreateBoat})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60 z-0" />

      <div className="relative w-full sm:max-w-lg lg:max-w-xl p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10 my-4">
        <div className="flex items-center space-x-3 mb-6 justify-center">
          <ShipIcon className="h-6 w-6 text-gray-800" />
          <h1 className="text-2xl font-bold text-gray-800">Embarcación</h1>
        </div>

        {error && <ErrorMessage message={error} dismissible />}

        {isLoading ? (
          <Loading />
        ) : team ? (
          <>
            {user?.roleId === UserRoles.PRIMARY_USER && (
              <BoatInfoPrimaryUser team={team} />
            )}
            {user?.roleId === UserRoles.INVITED_USER && (
              <BoatInfoDisplay team={team} />
            )}
          </>
        ) : null}
      </div>
    </div>
  );
}
